import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

export const ProductCardSkeletonWrapper = styled.div`
    width: 100%;
`;

export const ImageSkeleton = styled(Skeleton)`
    height: 15rem;
    margin-bottom: 1rem;
`;

export const TitleSkeleton = styled(Skeleton)`
    height: 1.5rem;
    margin-bottom: 1rem;
`;

export const DescriptionSkeleton = styled(Skeleton)`
    height: 1.5rem;
`;
